import createRoute    from '@widesk-ui/tools/createRoute';
import UserGroupModel from '@models/website/UserGroupModel';

const route = createRoute.dashboardFromModel(
	UserGroupModel,
	'UserGroupDashboard',
	{
		pathPrefix: '/configuration',
	},
);
export default route;
